<template>
	<div id="mis-amigos-page">
		<div class="mis-amigos-header">
			<div class="breadcrumb">
				<router-link :to="{ name: 'home' }" class="breadcrumb-item">Inicio</router-link>
				<div class="breadcrumb-item">&#8594;</div>
				<router-link :to="{ name: 'informacion-personal' }" class="breadcrumb-item">Cuenta</router-link>
				<div class="breadcrumb-item">&#8594;</div>
				<div class="breadcrumb-item">Mis Amigos</div>
			</div>
			<h1>Mis Amigos</h1>
		</div>
        <div class="amigos-row" v-if="!isCargandoAmigos && amigos.length > 0">
            <div class="amigo" v-for="amigo in amigos" :amigo="amigo" :key="amigo.PersonaId">
				<div class="amigo-left">
					<span class="nombre">{{ amigo.PersonaNombreCompleto }}</span>
					<span class="tipo-documento">{{ amigo.PersonaDocumentoTipoNombre }}</span>
					<span class="documento">{{ amigo.PersonaDocumento }}</span>
				</div>
				<div class="amigo-right" @click="eliminarAmigo(amigo)">
					<i class='bx bx-trash'></i>
				</div>
			</div>
        </div>
		<clip-loader :loading="isCargandoAmigos" :color="'var(--color-blue-link)'" :size="'52px'" style="margin: 60px auto;" v-else-if="isCargandoAmigos"></clip-loader>
		<div class="no-amigos" v-else-if="amigos.length <= 0">
			<span class="no-amigos-span">Aún no tienes amigos. Cuando le compres la entrada a un amigo, podrás verlo aquí para facilitar futuras compras.</span>
		</div>
		<!-- <modal name="promptEliminarAmigo" class="promptEliminarAmigo" transition="scale" mode="in-out" :clickToClose="true" @closed="promptEliminarAmigoClosed()">
			<div class="eliminar-amigo-content">
				<div class="eliminar-amigo-main">
					<span class="atencion-text">¿Estás seguro que deseas eliminar este amigo?</span>
				</div>
				<div class="buttons">
					<button class="no-quedarme" @click="$modal.hide('promptEliminarAmigo')">Cancelar</button>
					<button class="si-cancelar" @click.prevent="eliminarAmigo(amigoSeleccionado)">Eliminar</button>
				</div>
			</div>
		</modal> -->
	</div>
</template>

<script>
	import axios from 'axios';
	const { mapState } = createNamespacedHelpers('AuthModule');
	import { createNamespacedHelpers } from 'vuex';
	import ClipLoader from 'vue-spinner/src/ClipLoader.vue'

	export default {
		data(){
			return {
				isCargandoAmigos: true,
				amigos: [],
				// amigoSeleccionado: null
			};

		},
		components: {
			ClipLoader
		},
		metaInfo: {
			title: 'Mis amigos',
			titleTemplate: '%s 🎟 LineUp Tickets'
		},
		computed: {
			...mapState({
				user: state => state.user	
			}),
		},
		async mounted(){
			this.getAmigos();
		},
		methods: {
			async getAmigos() {
				try {
					this.isCargandoAmigos = true
					let response = await axios.post(
						'/WSAmigosListar',
						{
							UsuarioId: this.user.UsuarioId
						},
						{ headers: {"Authorization" : `Bearer ${ this.user.AccessToken }`} }
					);
					if (response.data.ErrorCod == 0) {
						this.amigos = response.data.SDTAmigos
					} else {
						this.$store.dispatch('showError', 'Ocurrió un error.')
						this.$router.push({ name: 'error' });
					}
				} catch (error) {
					this.$store.dispatch('showError', 'Ocurrió un error.')
					this.$router.push({ name: 'error' });
				} finally {
					this.isCargandoAmigos = false
				}
			},
			async eliminarAmigo(amigo){
				try{
					let response = await axios.post('/WSAmigoEliminar', {
							UsuarioId: this.user.UsuarioId,
							AmigoPersonaId: amigo.PersonaId
						}, { headers: {"Authorization" : `Bearer ${ this.user.AccessToken }`} }
					);
					
					if (response.data.ErrorCod === 0){
						this.amigos = response.data.SDTAmigos
						this.$store.dispatch('showSuccess', 'Amigo eliminado.')
						// this.$modal.hide('promptConfirmarEliminar');
					} else{
						this.$store.dispatch('showError', 'Ocurrió un error.')
						// this.$modal.hide('promptConfirmarEliminar');
					}

				} catch (error){
					this.$store.dispatch('showError', 'Ocurrió un error.')
					// this.$modal.hide('promptConfirmarEliminar');
				}
			},
			// async seleccionarAmigo(amigo){
			// 	this.amigoSeleccionado = amigo
			// 	this.$modal.show('promptEliminarAmigo')
			// },
			// promptEliminarAmigoClosed(){
			// 	this.amigoSeleccionado = null
			// }
		}
	}
</script>

<style lang="scss" scoped>
	#mis-amigos-page{
		width: 100%;
		@include flex(column, flex-start, flex-start);

		.mis-amigos-header{
			width: 100%;
			@include flex(column, flex-start, flex-start);
			margin-bottom: 40px;

			.breadcrumb {
				@include flex(row, flex-start, center);

				.breadcrumb-item {
					font-size: 12px;
					font-weight: var(--fw-600);
					letter-spacing: 0.3px;
					font-family: var(--font-sora);
					color: var(--color-darker);
					text-transform: capitalize;
					padding: 0px 5px;

					&:first-child{
						padding: 0px 5px 0px 0px;
					}
				}
			}

			h1{
				margin: 0;
				margin-top: 12px;
				font-family: var(--font-sora);
				font-size: 30px;
				line-height: 1em;
			}
		}

        .amigos-row {
			width: 100%;
			display: grid;
			grid-template-columns: repeat(3, 1fr);
			grid-auto-rows: 1fr;
			grid-column-gap: 20px;
			grid-row-gap: 20px;
			margin: 10px 0px;

			.amigo{
				width: 100%;
				border: 1px solid rgba(0, 0, 0, 0.15);
				padding: 14px 20px;
				border-radius: 8px;
				overflow: hidden;
				position: relative;
				cursor: pointer;
				z-index: 2;
				@include flex(row, space-between, flex-start);
				@include transition(all 140ms ease-in);

				.amigo-left{
					width: calc(100% - 48px);
					@include flex(column, center, flex-start);

					.nombre{
						font-size: 14px;
						font-weight: var(--fw-600);
						margin-bottom: 15px;
					}

					.tipo-documento{
						font-size: 11px;
						font-weight: var(--fw-400);
						text-transform: uppercase;
						margin-bottom: 5px;
						letter-spacing: 0.5px;
					}

					.documento{
						font-size: 11px;
						font-weight: var(--fw-600);
						letter-spacing: 0.5px;
					}
				}

				.amigo-right{
					@include flex(row, center, center);
					border-radius: 99%;
					background-color: var(--color-red-error);
					width: 28px;
					height: 28px;
					@include transition(all .2s);
					
					i{
						color: var(--color-white);
					}

					&:hover{
						opacity: 0.9;
					}
				}
			}
		}

		.no-amigos{
			@include flex(row, center, center);

			.no-amigos-span{
				width: 100%;
				background-color: #e8e9eb;
				padding: 10px;
				font-size: 12px;
				border-radius: 8px;
				line-height: 1.3em;
				margin-bottom: 20px;
			}
		}
	}

    @media screen and (max-width: 1300px){
		#mis-amigos-page{
			.amigos-row{
				grid-template-columns: repeat(3, 1fr);
			}
		}
	}

    @media screen and (max-width: 890px){
		#mis-amigos-page{
			.amigos-row{
				grid-template-columns: repeat(2, 1fr);
			}
		}
	}

    @media screen and (max-width: 620px){
		#mis-amigos-page{
			h3 {
				font-size: 11px;
			}

			h1 {
				margin-top: 5px;
				margin-bottom: 20px;
				font-size: 22px;
			}

			.amigos-row{
				grid-template-columns: repeat(1, 1fr);
			}
		}
	}
</style>